import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-wrapper" }
const _hoisted_2 = { class: "records-table" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-left observation-column" }
const _hoisted_6 = { class: "text-left observation-column" }
const _hoisted_7 = { class: "record-month" }
const _hoisted_8 = { class: "record-month" }
const _hoisted_9 = { class: "record-month" }
const _hoisted_10 = { class: "record-month" }
const _hoisted_11 = { class: "record-month" }
const _hoisted_12 = { class: "record-month" }
const _hoisted_13 = { class: "record-month" }
const _hoisted_14 = { class: "record-month" }
const _hoisted_15 = { class: "record-month" }
const _hoisted_16 = { class: "record-month" }
const _hoisted_17 = { class: "record-month" }
const _hoisted_18 = { class: "record-month" }
const _hoisted_19 = { class: "record-month" }
const _hoisted_20 = { class: "observation-column" }
const _hoisted_21 = { class: "observation-column" }
const _hoisted_22 = { class: "record-month-cell" }
const _hoisted_23 = { class: "record-month-cell" }
const _hoisted_24 = { class: "record-month-cell" }
const _hoisted_25 = { class: "record-month-cell" }
const _hoisted_26 = { class: "record-month-cell" }
const _hoisted_27 = { class: "record-month-cell" }
const _hoisted_28 = { class: "record-month-cell" }
const _hoisted_29 = { class: "record-month-cell" }
const _hoisted_30 = { class: "record-month-cell" }
const _hoisted_31 = { class: "record-month-cell" }
const _hoisted_32 = { class: "record-month-cell" }
const _hoisted_33 = { class: "record-month-cell" }
const _hoisted_34 = { class: "record-month-cell" }
const _hoisted_35 = {
  class: "d-flex sticky-footer",
  style: {"width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: [
          { title: 'Child Development', href: '/child-development', color: 'primary' },
          { title: `Class`, href: _ctx.childClassId ? `/child-development/class/${_ctx.year}/${_ctx.childClassId}` : undefined, color: 'primary', disabled: !_ctx.childClassId },
          { title: `${_ctx.childName} (${_ctx.year} ${_ctx.$t('childDevelopment.fiscalYear')})` },
        ]
      }, null, 8, ["items"])
    ]),
    _createVNode(_component_page_title, {
      value: `${_ctx.$t('childDevelopment.title')} - ${_ctx.childName} (${_ctx.year} ${_ctx.$t('childDevelopment.fiscalYear')})`
    }, null, 8, ["value"]),
    _createVNode(_component_v_alert, {
      class: "my-4",
      type: "info",
      color: "primary",
      variant: "outlined",
      density: "compact",
      style: {"font-size":"0.9rem"}
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('childDevelopment.evaluationCriteria')), 1),
        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" ○：" + _toDisplayString(_ctx.$t('childDevelopment.achieved')), 1),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" △：" + _toDisplayString(_ctx.$t('childDevelopment.attempting')), 1),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
        _createTextVNode("   - ：" + _toDisplayString(_ctx.$t('childDevelopment.notAchieved')), 1),
        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1))
      ]),
      _: 1
    }),
    (_ctx.isFetchingRecords)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "primary",
          class: "my-4"
        }))
      : (_ctx.records.length === 0)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 1,
            type: "info",
            color: "primary",
            variant: "outlined",
            density: "compact",
            class: "my-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('childDevelopment.noItemsSet')), 1)
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_table, {
                  class: "records-v-table",
                  "fixed-header": "",
                  height: "calc(100vh - 310px)"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('childDevelopment.domain')), 1),
                        _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('childDevelopment.item')), 1),
                        _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('childDevelopment.observationContent')), 1),
                        _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('childDevelopment.observationPoint')), 1),
                        _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('childDevelopment.previousYearAchieved')), 1),
                        _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('months.8')), 1),
                        _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('months.9')), 1),
                        _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('months.10')), 1),
                        _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('months.11')), 1),
                        _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('months.12')), 1),
                        _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('months.1')), 1),
                        _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('months.2')), 1),
                        _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('months.3')), 1),
                        _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('months.4')), 1),
                        _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('months.5')), 1),
                        _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('months.6')), 1),
                        _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('months.7')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (r, i) => {
                        return (_openBlock(), _createElementBlock("tr", { key: i }, [
                          _createElementVNode("td", null, _toDisplayString(`${r.domain.name} `), 1),
                          _createElementVNode("td", null, _toDisplayString(`${r.field} `), 1),
                          _createElementVNode("td", _hoisted_20, _toDisplayString(r.observationContent || '-'), 1),
                          _createElementVNode("td", _hoisted_21, _toDisplayString(r.observationPoint || '-'), 1),
                          _createElementVNode("td", _hoisted_22, [
                            _createVNode(_component_v_select, {
                              items: _ctx.selectOptions,
                              "item-title": "title",
                              "item-value": "value",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              modelValue: r.milestone.prevYear,
                              "onUpdate:modelValue": ($event: any) => ((r.milestone.prevYear) = $event)
                            }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_23, [
                            (_ctx.shouldShowInput(r, 'aug'))
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 0,
                                  items: _ctx.selectOptions,
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  modelValue: r.milestone.aug,
                                  "onUpdate:modelValue": ($event: any) => ((r.milestone.aug) = $event)
                                }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_24, [
                            (_ctx.shouldShowInput(r, 'sept'))
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 0,
                                  items: _ctx.selectOptions,
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  modelValue: r.milestone.sept,
                                  "onUpdate:modelValue": ($event: any) => ((r.milestone.sept) = $event)
                                }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_25, [
                            (_ctx.shouldShowInput(r, 'oct'))
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 0,
                                  items: _ctx.selectOptions,
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  modelValue: r.milestone.oct,
                                  "onUpdate:modelValue": ($event: any) => ((r.milestone.oct) = $event)
                                }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_26, [
                            (_ctx.shouldShowInput(r, 'nov'))
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 0,
                                  items: _ctx.selectOptions,
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  modelValue: r.milestone.nov,
                                  "onUpdate:modelValue": ($event: any) => ((r.milestone.nov) = $event)
                                }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_27, [
                            (_ctx.shouldShowInput(r, 'dec'))
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 0,
                                  items: _ctx.selectOptions,
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  modelValue: r.milestone.dec,
                                  "onUpdate:modelValue": ($event: any) => ((r.milestone.dec) = $event)
                                }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_28, [
                            (_ctx.shouldShowInput(r, 'jan'))
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 0,
                                  items: _ctx.selectOptions,
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  modelValue: r.milestone.jan,
                                  "onUpdate:modelValue": ($event: any) => ((r.milestone.jan) = $event)
                                }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_29, [
                            (_ctx.shouldShowInput(r, 'feb'))
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 0,
                                  items: _ctx.selectOptions,
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  modelValue: r.milestone.feb,
                                  "onUpdate:modelValue": ($event: any) => ((r.milestone.feb) = $event)
                                }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_30, [
                            (_ctx.shouldShowInput(r, 'mar'))
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 0,
                                  items: _ctx.selectOptions,
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  modelValue: r.milestone.mar,
                                  "onUpdate:modelValue": ($event: any) => ((r.milestone.mar) = $event)
                                }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_31, [
                            (_ctx.shouldShowInput(r, 'apr'))
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 0,
                                  items: _ctx.selectOptions,
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  modelValue: r.milestone.apr,
                                  "onUpdate:modelValue": ($event: any) => ((r.milestone.apr) = $event)
                                }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_32, [
                            (_ctx.shouldShowInput(r, 'may'))
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 0,
                                  items: _ctx.selectOptions,
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  modelValue: r.milestone.may,
                                  "onUpdate:modelValue": ($event: any) => ((r.milestone.may) = $event)
                                }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_33, [
                            (_ctx.shouldShowInput(r, 'june'))
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 0,
                                  items: _ctx.selectOptions,
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  modelValue: r.milestone.june,
                                  "onUpdate:modelValue": ($event: any) => ((r.milestone.june) = $event)
                                }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_34, [
                            (_ctx.shouldShowInput(r, 'july'))
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 0,
                                  items: _ctx.selectOptions,
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  modelValue: r.milestone.july,
                                  "onUpdate:modelValue": ($event: any) => ((r.milestone.july) = $event)
                                }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                large: "",
                variant: "flat",
                color: "primary",
                onClick: _ctx.updateRecords,
                loading: _ctx.isUpdating,
                disabled: _ctx.isUpdating
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('childDevelopment.save')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "loading", "disabled"]),
              _createVNode(_component_v_spacer)
            ])
          ], 64))
  ]))
}